<template>
	<div class="pga-tournament-pool-about-page">
		<div class="pga-tournament-pool-about-page__content">
			<div class="header-section">
				<h3 class="header">NFL Weekly Picke'em</h3>
			</div>
		</div>
	</div>
</template>

<script>

	export default {

	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/pga/pga-tournament-pool/about';
</style>